export default "__VITE_ASSET__Hz1HcvxY__"